<template>
<nav aria-label="breadcrumb" class="breadcrumb-area">
  <ol class="breadcrumb">
    <li class="breadcrumb-item"><router-link to="/">HOME</router-link></li>
	<li class="breadcrumb-item"><router-link to="/mypage/index">マイページ</router-link></li>
    <li class="breadcrumb-item active" aria-current="page">プロフィール変更完了</li>
  </ol>
</nav>
	<div class="container-fluid">
		<div class="row mypage-contents">
			<side-bar/>
			<div class="mypage-contents_contents ml-sm-auto px-md-4 py-4">
				<h1>プロフィール変更完了</h1>
				<div class="top--section">
					<p>
						プロフィール変更が完了しました。<br>
					</p>
					<router-link to="/mypage/index" class="btn btn-primary">マイページへ戻る</router-link>
				</div>
			</div>
		</div>
	</div>
</template>

<script setup lang="ts">
import SideBar from '@/components/Layouts/SideBar.vue'
</script>
